/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmExecutionGroupBatchResponse {
    getFixupPrototypeFunction() { return AwsSsmExecutionGroupBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmExecutionGroupBatchResponse>): AwsSsmExecutionGroupBatchResponse {
        let obj = Object.assign(new AwsSsmExecutionGroupBatchResponse(), model);
        AwsSsmExecutionGroupBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmExecutionGroupBatchResponse>): AwsSsmExecutionGroupBatchResponse {
        if (!model) return null;
        return AwsSsmExecutionGroupBatchResponse.newInstance(<AwsSsmExecutionGroupBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmExecutionGroupBatchResponse) {
        if (!obj) return;

        models.AwsSsmExecutionGroupBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmExecutionGroupBatchResponse): boolean {
        Object.setPrototypeOf(obj, AwsSsmExecutionGroupBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AwsSsmJobGroup.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AwsSsmJobGroup; };

}
